// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {buildPayload} from '../../../tcsm/wip/services/machine-status-build-payload';
import {getFileName} from '../../../shared/services/get-file-name';
import {getMachineStatusUpdates} from '../repositories';
import {getUser} from '../../../shared/services/get-user';
import {openFile} from '../../../shared/services/open-file';

const getSelectedAccountIds = selectedAccounts =>
    selectedAccounts.map(selectedAccount => selectedAccount.account || selectedAccount);

export const readMachineStatusUpdates = selectedAccounts =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        const payload = buildPayload(getSelectedAccountIds(selectedAccounts));

        try {

            const data = await getMachineStatusUpdates(payload);

            dispatch({
                data,
                type: actions.UPDATE_PRODUCT_MACHINE_STATUS_UPDATES
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const exportMachineStatusUpdates = selectedAccounts =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        const payload = buildPayload(getSelectedAccountIds(selectedAccounts), 'EXCEL', getUser().getLocale(), 'Machine Status Updates');

        try {

            const response = await getMachineStatusUpdates(payload);
            const fileName = getFileName(response);
            const blob = await response.blob();

            openFile(blob, fileName, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/product/machine-status-update/action-creators/get-machine-status-updates.js